/* One coalesced measurement per frame, with teardown for editor and bfcache. */
(() => {
  'use strict';
  if (window.GrowplayStickySignup) return;
  const instances = new Map();
  const mobile = matchMedia('(max-width: 979px)');
  function init(root) {
    root.querySelectorAll('.growplay-email-signup').forEach(bar => {
      const section = bar.closest('.shopify-section');
      if (!section || instances.has(section)) return;
      const headers = ['header', 'mobile-header'].map(id => document.getElementById(id)).filter(Boolean);
      let raf = 0, settle = 0;
      const measure = () => {
        raf = 0;
        const viewport = innerHeight || document.documentElement.clientHeight;
        const height = headers.reduce((max, header) => {
          const rect = header.getBoundingClientRect();
          if (!rect.height || !rect.width) return max;
          return Math.max(max, Math.max(0, Math.min(rect.height, Math.min(rect.bottom, viewport) - Math.max(rect.top, 0))));
        }, 0);
        const offset = Math.ceil(height) + 'px';
        if (section.style.getPropertyValue('--gp-email-signup-sticky-top') !== offset) {
          section.style.setProperty('--gp-email-signup-sticky-top', offset);
        }
        section.classList.toggle('is-compact', scrollY > 8 && mobile.matches);
      };
      const schedule = () => {
        if (!raf) raf = requestAnimationFrame(measure);
        clearTimeout(settle);
        settle = setTimeout(() => { if (!raf) raf = requestAnimationFrame(measure); }, 160);
      };
      const resize = new ResizeObserver(schedule);
      const mutation = new MutationObserver(schedule);
      const wrappers = new Set();
      headers.forEach(header => {
        resize.observe(header);
        const wrapper = header.closest('.header-sticky-wrapper, #mobile-header-sticky-wrapper');
        if (wrapper && !wrappers.has(wrapper)) {
          wrappers.add(wrapper);
          mutation.observe(wrapper, {attributes: true, attributeFilter: ['class', 'style']});
        }
      });
      ['load', 'resize', 'scroll', 'gp:header-visibility'].forEach(name => window.addEventListener(name, schedule, {passive: true}));
      mobile.addEventListener('change', schedule);
      instances.set(section, () => {
        cancelAnimationFrame(raf); clearTimeout(settle);
        resize.disconnect(); mutation.disconnect();
        ['load', 'resize', 'scroll', 'gp:header-visibility'].forEach(name => window.removeEventListener(name, schedule));
        mobile.removeEventListener('change', schedule);
      });
      measure();
    });
  }
  const destroy = section => { instances.get(section)?.(); instances.delete(section); };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  window.addEventListener('pagehide', () => [...instances.keys()].forEach(destroy));
  window.addEventListener('pageshow', () => init(document));
  window.GrowplayStickySignup = {init};
  init(document);
})();
